export default {
    confirmation: {
        title: 'Really remove participants?',
        content: 'This step can not be undone',
        confirm: 'Yes, remove participants'
    },
    empty: 'No users in this panel have been added to an internal rating yet'
}
